<div class="modal no-overflow" [ngClass]="state.visible ? 'show' : ''">
  <div class="modal__layer"></div>
  <div class="modal__box modal__box--small absolute-centering" [ngClass]="state.visible ? 'show' : ''">
    <div class="modal__box__head">
      {{state.title}}
    </div>
    <div class="modal__box__body max-height">
      <p style="margin-top: 0; margin-bottom: 0;">
        {{state.text}}
      </p>
    </div>
  </div>
</div>
